import { useEffect } from 'react';

const liveActivities = [
  {
    id: 1,
    title: '상생을 위한 가치 소비 "Live방송"',
    description: '화려한 포장보다는 생산자의 땀방울과 정성에 주목합니다. 좋은 제품 속에 숨겨진 진짜 가치를 찾아내 시청자에게 생생하게 전달합니다.',
    thumbnail: 'https://static.readdy.ai/image/3c653b3a8a919d24e4f7a2804547f79c/a8e55d864ba5cd6b35ce2db1ae674e17.png',
    icon: 'ri-heart-line',
    buttonColor: '#FF6B6B'
  },
  {
    id: 2,
    title: '새로운 도전 "쇼호스트 교육"',
    description: '카메라 앞이 낯선 분들도 괜찮습니다. 당신이 가진 고유한 진정성을 꺼내어 누군가의 마음을 움직일 수 있도록, 가장 든든하고 친절한 러닝메이트가 되어 드립니다.',
    thumbnail: 'https://public.readdy.ai/ai/img_res/100cf0cce1298b3b333119fed80acd47.jpg',
    icon: 'ri-graduation-cap-line',
    buttonColor: '#FFA500'
  },
  {
    id: 3,
    title: '착한 소비 스마트 스토어',
    description: '정직하게 만든 좋은 제품을 소개하는 공간입니다. 여러분의 따뜻한 클릭 한 번이 작은 기업에 큰 희망이 되고, 우리 지역사회에 기분 좋은 활력이 됩니다.',
    thumbnail: 'https://readdy.ai/api/search-image?query=korean%20small%20business%20handmade%20products%20artisan%20crafts%20authentic%20local%20goods%20bright%20colorful%20display%20traditional%20korean%20items%20modern%20presentation%20vibrant%20photography%20genuine%20quality%20products%20warm%20inviting%20atmosphere%20vivid%20colors%20realistic%20style&width=600&height=400&seq=live_store1&orientation=landscape',
    icon: 'ri-store-line',
    buttonColor: '#4CAF50'
  }
];

export default function LiveSection() {
  useEffect(() => {
    const style = document.createElement('style');
    style.innerHTML = `
      @font-face {
        font-family: 'FounderYooGeonWook';
        src: url('https://cdn.jsdelivr.net/gh/projectnoonnu/noonfonts_2112@1.0/establishRetrosansOTF.woff') format('woff');
        font-weight: normal;
        font-display: swap;
      }
    `;
    document.head.appendChild(style);
  }, []);

  return (
    <section id="live" className="py-16 md:py-24 px-4 md:px-6" style={{ backgroundColor: '#00E5FF' }}>
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-16">
          <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl mx-auto mb-4 md:mb-6" style={{ backgroundColor: 'rgba(0,47,108,0.15)' }}>
            <i className="ri-live-line text-3xl md:text-4xl" style={{ color: '#002F6C' }}></i>
          </div>
          <h2 className="text-4xl md:text-6xl font-extrabold mb-4 md:mb-6" style={{ fontFamily: "'FounderYooGeonWook', sans-serif", color: '#002F6C' }}>
            마음을 다하는 라이브커머스
          </h2>
          <p className="text-base md:text-xl max-w-3xl mx-auto font-semibold leading-relaxed" style={{ color: '#002F6C' }}>
            단순한 판매를 넘어, 가치를 나누고 지역사회와 상생하는<br />
            따뜻한 라이브 방송을 만듭니다.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {liveActivities.map((activity) => (
            <div
              key={activity.id}
              className="bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:scale-105 cursor-default"
            >
              <div className="w-full h-56 md:h-64 relative">
                <img
                  src={activity.thumbnail}
                  alt={activity.title}
                  className="w-full h-full object-cover object-center"
                />
                <div className="absolute top-4 left-4 w-12 h-12 flex items-center justify-center rounded-full" style={{ backgroundColor: 'rgba(255,255,255,0.95)' }}>
                  <i className={`${activity.icon} text-2xl`} style={{ color: activity.buttonColor }}></i>
                </div>
              </div>

              <div className="p-5 md:p-6">
                <h3 className="text-xl md:text-2xl font-bold mb-3 md:mb-4" style={{ color: '#002F6C' }}>
                  {activity.title}
                </h3>

                <p className="text-gray-600 text-sm md:text-base leading-relaxed mb-5 md:mb-6">
                  {activity.description}
                </p>

                <button 
                  onClick={() => {
                    if (activity.id === 1) {
                      window.open('https://www.youtube.com/playlist?list=PLRf2wnMZI5Yi-VUz3QL2NbZK8KOQg_FJt', '_blank');
                    } else if (activity.id === 2) {
                      window.REACT_APP_NAVIGATE('/showhost-training');
                    } else if (activity.id === 3) {
                      window.open('https://smartstore.naver.com/gjsenet?NaPm=ct%3Dmmajloa8%7Cci%3Dshopn%7Ctr%3Dnslsl%7Chk%3Df7aaa2d4437e8e5562e84d93b46c651f6c062f8e%7Ctrx%3Dundefined', '_blank');
                    }
                  }}
                  className="w-full py-3 rounded-full font-bold text-white text-sm md:text-base transition-all duration-300 hover:shadow-lg whitespace-nowrap cursor-pointer"
                  style={{ backgroundColor: activity.buttonColor }}
                >
                  자세히 보기
                  <i className="ri-arrow-right-line ml-2"></i>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}